import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import { allowShippingQuoteOnStore } from '../../../_views/shipping_quote/common';
import Translation from '../translation/translation';
import initializeTargetComponent, { initializeConfiguratorComponents } from '../../../_views/initialize_component';
import { onOpenRegoLookupClick, onOpenVehicleConfiguratorClick } from '../../../_views/configurator_buttons/configurator_buttons';
import VehicleFilterStore from '../../stores/vehicle_configurator_store';
import RegoLookupStore from '../../stores/rego_lookup_store';
import LastUsedConfiguratorStore from '../../stores/last_used_configurator_store';
import CONFIGURATOR_TYPES from '../../constants/configurator_types';
import getTranslatedText from '../../helper/get_translated_text';
import Tooltip from '../tooltip/tooltip';
import { Filters } from '../../constants/filter/filters';
import { showAction as showVehicleDetailsAction } from '../../actions/vehicle_details_light_box_actions';

const {
    store,
} = TYROOLA.globals;

const setConfigText = (data) => {
    return (data || 'not found');
}

class VehicleDetails extends Component {
    constructor() {
        super();
        this.state = {
            lastUsedConfiguratorStore: LastUsedConfiguratorStore.getState(),
            regoLookupStore: RegoLookupStore.getState(),
            vehicleConfiguratorStore: VehicleFilterStore.getState(),
        };
    }

    componentDidMount() {
        if (allowShippingQuoteOnStore(store)) {
            LastUsedConfiguratorStore.addListener(() => this._getLastUsedConfiguratorStore());
            RegoLookupStore.addListener(() => this._getRegoLookupStore());
            VehicleFilterStore.addListener(() => this._getVehicleConfiguratorStore());
        }
    }

    componentDidUpdate() {
        const productType = 'tyre';
        const catalogConfiguratorOptions = { productType, staticUrl: TYROOLA.globals.staticUrl };

        const { lastUsedConfiguratorStore } = this.state;
        const lastUsedConfigurator = lastUsedConfiguratorStore.configuratorSource;
        const showVehicleDetail = [CONFIGURATOR_TYPES.VEHICLE_CONFIGURATOR, CONFIGURATOR_TYPES.REGO_LOOKUP].indexOf(lastUsedConfigurator) >= 0;
        let isVehicleConfigurator = false;

        if (true === showVehicleDetail) {
            if ('vehicle_configurator' === lastUsedConfigurator) {
                isVehicleConfigurator = true;
            }
        }

        initializeTargetComponent(
            'a[href="#open-configurator"]',
            initializeConfiguratorComponents.bind(this, catalogConfiguratorOptions, false),
            (isVehicleConfigurator ? onOpenVehicleConfiguratorClick : onOpenRegoLookupClick)
        );
    }

    componentWillUnmount() {
        LastUsedConfiguratorStore.addListener(() => this._getLastUsedConfiguratorStore());
        RegoLookupStore.addListener(() => this._getRegoLookupStore());
        VehicleFilterStore.addListener(() => this._getVehicleConfiguratorStore());
    }

    _getLastUsedConfiguratorStore() {
        this.setState({
            lastUsedConfiguratorStore: LastUsedConfiguratorStore.getState(),
        });
    }

    _getRegoLookupStore() {
        this.setState({
            regoLookupStore: RegoLookupStore.getState(),
        });
    }

    _getVehicleConfiguratorStore() {
        this.setState({
            vehicleConfiguratorStore: VehicleFilterStore.getState(),
        });
    }

    _showVehicleDetailLightbox() {
        showVehicleDetailsAction();
    }

    _getVehcileDetailsDisplayMessage(vehcileDetails, cartProducts) {
        const displayMessage = { message: '', color: '' };
        const { vehicleId, tyreOptions } = vehcileDetails;
        const isNum = /^\d+$/.test(vehicleId);

        if (cartProducts) {
            if (vehicleId && isNum) {
                const productsMap = cartProducts.filter(p => p.type === 'tyre');

                // No tyres in the cart
                if (!productsMap.length) {
                    displayMessage.message = 'vehicle-details-thanks-for-providing-vehicle-message';
                    displayMessage.color = 'green';
                } else { // Tyres available in the cart
                    let matchedProductsLength = 0;

                    productsMap.forEach(product => {
                        if (tyreOptions && tyreOptions
                            .filter(tyreOption =>
                                `${product.width}${product.height}${product.diameter}` === `${tyreOption.width}${tyreOption.height}${tyreOption.rimSize}`
                                && product.speedIndexNumeric >= tyreOption.speedIndexNumeric
                                && product.loadIndex >= tyreOption.loadIndex
                            ).length) {
                            matchedProductsLength += 1;
                        }
                    });

                    if (productsMap.length > 1) { // Multiple SpinachIds with type as tyre
                        if (matchedProductsLength && matchedProductsLength === productsMap.length) { // All Products matched
                            displayMessage.message = 'vehicle-details-all-tyres-fit-message';
                            displayMessage.color = 'green';
                        } else if (matchedProductsLength && matchedProductsLength !== productsMap.length) { // Some of the Products matched
                            displayMessage.message = 'vehicle-details-some-tyres-not-fit-message';
                            displayMessage.color = 'orange';
                        } else { // None of the Products matched
                            displayMessage.message = 'vehicle-details-none-tyres-fit-message';
                            displayMessage.color = 'red';
                        }
                    } else { // Single SpinachIds with type as tyre
                        if (matchedProductsLength) { // Product matched
                            displayMessage.message = 'vehicle-details-all-tyres-fit-message';
                            displayMessage.color = 'green';
                        } else { // Product not matched
                            displayMessage.message = 'vehicle-details-none-tyres-fit-message';
                            displayMessage.color = 'red';
                        }
                    }
                }
            } else {
                displayMessage.message = 'vehicle-details-thanks-for-providing-vehicle-message';
                displayMessage.color = 'green';
            }
        }

        return displayMessage;
    }

    render() {
        const { lastUsedConfiguratorStore, regoLookupStore, vehicleConfiguratorStore } = this.state;
        const lastUsedConfigurator = lastUsedConfiguratorStore.configuratorSource;
        const isVehicleProvided = lastUsedConfiguratorStore.isVehicleProvided;
        const vehicleNotProvidedComment = lastUsedConfiguratorStore.vehicleNotProvidedComment;
        const showVehicleDetail = [CONFIGURATOR_TYPES.VEHICLE_CONFIGURATOR, CONFIGURATOR_TYPES.REGO_LOOKUP].indexOf(lastUsedConfigurator) >= 0;
        let configuratorValues = null;
        let vehicleTooltipLabel = null;
        let vehicleTooltipContent = null;
        let displayMessage = { message: '', color: '' };

        if (true === showVehicleDetail) {
            if ('vehicle_configurator' === lastUsedConfigurator) {
                if (vehicleConfiguratorStore.values
                    && vehicleConfiguratorStore.values.make
                    && vehicleConfiguratorStore.values.vehicle_model
                    && vehicleConfiguratorStore.values.year) {
                    configuratorValues = vehicleConfiguratorStore.values;
                }
            } else if (regoLookupStore.values && regoLookupStore.values.registration) {
                configuratorValues = regoLookupStore.values;
            }
        }

        if (configuratorValues) {
            const { VEHICLE_MAKE, VEHICLE_MODEL, VEHICLE_YEAR, REGISTRATION, VEHICLE_SERIES_CHASSIS, VEHICLE_ENGINE, VEHICLE_DETAILS, VEHICLE_SERIES, VEHICLE_CHASSIS } = Filters;
            displayMessage = this._getVehcileDetailsDisplayMessage(configuratorValues, TYROOLA.initialFluxStates.cartProducts);

            vehicleTooltipLabel = (<>
                <div><Translation translationKey='vehicle-configurator-make-select-label' />: {setConfigText(configuratorValues[VEHICLE_MAKE])}</div>
                <div><Translation translationKey='vehicle-configurator-model-select-label' />: {setConfigText(configuratorValues[VEHICLE_MODEL])}</div>
                {
                    !configuratorValues.registration && <div><Translation translationKey='vehicle-configurator-year-select-label' />: {setConfigText(configuratorValues[VEHICLE_YEAR])}</div>
                }
                {
                    configuratorValues.registration && <div><Translation translationKey='rego-lookup-label' />: <span style={{ textTransform: 'uppercase' }}>{setConfigText(configuratorValues[REGISTRATION])}</span></div>
                }
            </>);

            vehicleTooltipContent = ReactDOMServer.renderToString(<>
                {vehicleTooltipLabel}
                {configuratorValues[VEHICLE_SERIES]
                    ? <div><Translation translationKey='vehicle-configurator-seriesChassis-select-label' />: {setConfigText(`${configuratorValues[VEHICLE_SERIES]} - ${configuratorValues[VEHICLE_CHASSIS]}`)}</div>
                    : <div><Translation translationKey='vehicle-configurator-seriesChassis-select-label' />: {setConfigText(configuratorValues[VEHICLE_SERIES_CHASSIS])}</div>
                }
                < div > <Translation translationKey='vehicle-configurator-engine-select-label' />: {setConfigText(configuratorValues[VEHICLE_ENGINE])}</div >
                <div><Translation translationKey='vehicle-configurator-details-select-label' />: {setConfigText(configuratorValues[VEHICLE_DETAILS])}</div>
            </>);
        }

        return (
            <table style={{ width: '100%' }}>
                <tbody>
                    <tr>
                        <td className='checkout-sidebar-style'>
                            <div>
                                <label className="checkout-summary__label">
                                    <Translation translationKey="your-vehicle-text" />
                                </label>
                                <span className="vehicle-details-more-info-button" onClick={this._showVehicleDetailLightbox}>?</span>
                            </div>

                            <div style={{ paddingLeft: '15px', fontSize: '13px', fontWeight: '300', lineHeight: '20px' }}>
                                {isVehicleProvided === false && <div className="vehicle-configurator-sorry-can-not-provide-vehicle-text" style={{ padding: '15px 0' }}>
                                    <Translation translationKey='vehicle-configurator-sorry-can-not-provide-vehicle-text' />
                                    {vehicleNotProvidedComment && <div  style={{ paddingTop: '15px', fontSize: '13px', fontWeight: '300', lineHeight: '20px' }}>{vehicleNotProvidedComment}</div>}
                                </div>}

                                {!configuratorValues && <>
                                    <Translation translationKey='vehicle-details-default-description' />
                                    <a href='#open-configurator' target='_self' className='cursor-pointer underline'>
                                        <Translation translationKey='select-here-text' />
                                    </a>
                                </>}

                                {configuratorValues && <>
                                    <Tooltip
                                        label={ReactDOMServer.renderToString(vehicleTooltipLabel)}
                                        content={vehicleTooltipContent}
                                        additionalClassNames={['product-image-placeholder-text', 'dotted-underline']}
                                    />
                                    <br />
                                    {
                                        displayMessage.message && <>
                                            <Translation className="vehicle-details-display-message" translationKey={displayMessage.message} style={{ color: displayMessage.color }} />
                                            <br />
                                            <br />
                                        </>
                                    }
                                    <div>
                                        <Translation translationKey='rego-lookup-confirmation-layer-not-your-vehicle' /> - <a href='#open-configurator' target='_self' className='cursor-pointer underline'><Translation translationKey='vehicle-configurator-confirmation-layer-change-here' /></a>
                                    </div>
                                </>}

                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

VehicleDetails.propTypes = {
    productType: PropTypes.string,
};

export { VehicleDetails };
